import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import QrRepository from "../../repositories/QrRepository";

interface _Props {
    qrRepository: QrRepository;
}

@injectable()
export default class DownloadQrBatchUseCase {
    private qrRepository: QrRepository;

    constructor(props: _Props) {
        this.qrRepository = props.qrRepository;
    }

    public call = async (id: string): Promise<Either<ErrorEntity, void>> => {
        return this.qrRepository.downloadQrBatch(id);
    }
}

export const DownloadQrBatchUseCaseName = "DownloadQrBatchUseCase";